<template>
  <!-- Header Section -->
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-lg-8 align-self-center">
      <h2 class="mb-0">Monitor Dashboard</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content px-0">
    <div class="modal-table-container">
      <div class="section-title">
        <span>Site Performance</span>
      </div>
      <div
        class="table-responsive"
        :class="{ 'scrollable-table': performanceList.length > 10 }"
      >
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th class="text-center">Rank</th>
              <th class="text-center">SiteCode</th>
              <th class="text-center">Average Risk Score</th>
              <th class="text-center">Total KPIs Analysed</th>
              <th class="text-center">Run Date</th>
              <th class="text-center">View</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="list in performanceList" :key="list.id">
              <td class="text-center">{{ list.rank }}</td>
              <td class="text-center">{{ list.siteCode }}</td>
              <td class="text-center">{{ list.averageRiskScore }}</td>
              <td class="text-center">{{ list.totalKPIsAnalysed }}</td>
              <td class="text-center">{{ formatRunDate(list.runDate) }}</td>
              <td class="text-center">
                <a @click.prevent="viewDocument(list.kpiWithScores)">
                  <i class="fa fa-eye edit-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <monitor-kpi-modal
    v-if="openModal"
    :kpiwithscores="kpiWithScores"
    @closeModal="closeModal"
  />
</template>
<script src="./monitorDashboard.js">
</script>
<style scoped>
.scrollable-table {
  max-height: 400px; /* adjust as needed */
  overflow-y: auto;
}
</style>